import { palette } from 'src/styles/colors';
import { layout } from 'src/styles/layout';
import styled from 'styled-components';

interface FeaturesMegaMenuContainerProps {
  isOpen: boolean;
  maxHeight: number;
}

export const FeaturesMegaMenuSideContainer = styled.div<FeaturesMegaMenuContainerProps>`
  position: relative;
  overflow: hidden;
  transition:
    max-height 0.3s ease-in-out,
    opacity 0.3s ease-in-out;
  max-height: ${({ isOpen, maxHeight }) => (isOpen ? maxHeight : 0)}px;
`;

export const FeaturesMegaMenuSideBarContent = styled.div`
  display: flex;
  flex-flow: row wrap;
  background-color: ${palette.white};

  @media all and (max-width: ${layout.subxlg}) {
    grid-template-columns: 640px 1fr;
  }
`;
